export default "__VITE_ASSET__BnTn_81O__"